import { Component } from "react"

/* Constants */
import { utils, env } from "../constants"

/* Widget Device */
class Device extends Component {

    constructor() {
        super()

        this.state = {
            thumbnail: null
        }
    }

    componentDidMount = () => {
        this.generateThumbnail()
    }

    /* Generate Thumbnail */
    generateThumbnail = () => {

        /* Fields */
        const { data } = this.props

        /* Check Video */
        if (!data.video) {
            return
        }

        /* Create Video */
        const video = document.createElement("video")
        video.src = `${env.point}${data.video}`
        video.crossOrigin = "anonymous"
        video.muted = true
        video.preload = "auto"

        /* On Load */
        video.addEventListener("loadeddata", () => {
            video.currentTime = 1
        })

        /* On Ready */
        video.addEventListener("seeked", () => {
            const canvas = document.createElement("canvas")
            canvas.width = video.videoWidth
            canvas.height = video.videoHeight

            const ctx = canvas.getContext("2d")
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

            const imageURL = canvas.toDataURL("image/jpeg")
            this.setState({ thumbnail: imageURL })
        })
    }

    render = () => {

        /* Fields */
        const { data, open } = this.props
        const { thumbnail } = this.state

        return (
            <div onClick={() => open(data.token)} className="container-user">

                {/* Thumbnail */}
                {thumbnail && <img src={thumbnail} alt="Thumbnail" className="container-thumbnail-image" />}

                <div className="container-user-inner">

                    <img src="/images/play-button.png" alt="Play" />

                    <div className="container-head">
                        {data.connection === 1 ? <div className="container-connection green">Онлайн</div> : <div className="container-connection red">Офлайн</div>}
                        {data.stream === 1 && <div className="container-stream">live</div>}
                    </div>
                    <div className="container-name">{data.name}</div>
                    <div className="container-bottom">
                        <div className="container-city">
                            <img src="/images/pin.png" alt="Pin" />
                            <span>{utils.check(data.country)} {utils.check(data.city)}</span>
                        </div>
                        <div className="container-phone">
                            <img src="/images/phone.png" alt="Phone" />
                            <span>{utils.check(data.device, "-")}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Device